import { Component } from '@angular/core';

@Component({
  selector: 'app-projects-status-info',
  standalone: false,
  templateUrl: './projects-status-info.component.html',
  styleUrl: './projects-status-info.component.scss',
})
export class ProjectsStatusInfoComponent {}
